export const calculatePercentageChange = (
  currentData: number,
  priorData: number,
  precision = 2,
): number => {
  if (priorData === 0) {
    return currentData === 0 ? 0 : 0; // Return 0 if both are 0
  }

  const percentage = ((currentData - priorData) / priorData) * 100;
  return precision === 0 ? Math.round(percentage) : Number(percentage.toFixed(precision));
};
